export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14448.78302be9.jpg";